import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ShopActions } from '../actions';
import { ShopListSelectors } from '../selectors';
import { StateWithShop } from '../shop-state';

@Injectable({
  providedIn: 'root',
})
export class ShopListFacade {
  constructor(private store: Store<StateWithShop>) {}

  loadShopList(): void {
    this.store.dispatch(new ShopActions.LoadShopList());
  }

  getShopListState(): Observable<StateUtils.LoaderState<Pos[]>> {
    return this.store.pipe(select(ShopListSelectors.getShopListState));
  }

  getShopList(): Observable<Pos[]> {
    return this.store.pipe(select(ShopListSelectors.getShopList));
  }

  getShopListLoading(): Observable<boolean> {
    return this.store.pipe(select(ShopListSelectors.getShopListLoading));
  }

  getShopListSuccess(): Observable<boolean> {
    return this.store.pipe(select(ShopListSelectors.getShopListSuccess));
  }

  getShopListError(): Observable<boolean> {
    return this.store.pipe(select(ShopListSelectors.getShopListError));
  }

  getNoPosAvailable(): Observable<boolean> {
    return this.store.pipe(
      select(ShopListSelectors.getShopListState),
      filter((value) => Boolean(!value.loading && (value.error || value.success))),
      map((value) => value.error || value.value?.length === 0),
    );
  }

  getShop(id?: string): Observable<Pos> {
    return this.store.pipe(select(ShopListSelectors.getShop(id)));
  }
}
